import { DatePicker, Input, InputNumber, message, Select, Switch } from 'antd';
import { postMerchantUpdate } from '@/api';
import { FormModal, UploadImage } from '@/components';
import { ergodicObj, toDateTime } from '@/utils/utils';
import { st_banner } from '@/utils/statetype';
import React, { useState } from 'react';

const { positionObj, typeObj } = st_banner;
function BannderEdit({ visible, data, onChange }) {
  const handleSubmit = async params => {
    console.log("params:", params)
    if (!params) return onChange();
    const { isRecommend, } = params;

    data.id && await postMerchantUpdate({
      body: {
        id: data.id,
        ...params,
        isRecommend: isRecommend ? 1 : 0,
      },
    })
    message.success('操作成功');
    onChange(true);
  };

  const formData = [
    data?.id && {
      name: 'id',
      label: '编号',
      rules: [{ required: false, message: '请输入编号' }],
      render: <InputNumber disabled placeholder="请输入编号" />,
    },
    {
      name: 'title',
      label: '店铺名称',
      rules: [{ required: true, message: '请输入店铺名称' }],
      render: <InputNumber placeholder="请输入店铺名称" />,
    },
    {
      name: 'shopIcon',
      label: '店铺logo',
      rules: [{ required: true, message: '请选择店铺logo' }],
      render: <UploadImage model="single" callBackString />,
    },
    {
      name: 'firmName',
      label: '企业名称',
      rules: [{ required: true, message: '请输入企业名称' }],
      render: <Input placeholder="请输入企业名称" />,
    },
    {
      name: 'creditCode',
      label: '社会信用代码',
      rules: [{ required: true, message: '请输入社会信用代码' }],
      render: <Input placeholder="请输入社会信用代码" />,
    },
    {
      name: 'name',
      label: '法人姓名',
      rules: [{ required: true, message: '请输入法人姓名' }],
      render: <Input placeholder="请输入法人姓名" />,
    },
    {
      name: 'contact',
      label: '联系方式',
      rules: [{ required: true, message: '请输入联系方式' }],
      render: <Input placeholder="请输入联系方式" />,
    },
    {
      name: 'address',
      label: '详细地址',
      rules: [{ required: true, message: '请输入详细地址' }],
      render: <Input placeholder="请输入详细地址" />,
    },
    {
      name: 'sort',
      label: '排序',
      rules: [{ required: false, message: '请输入排序' }],
      render: <Input placeholder="请输入排序" />,
    },
    {
      name: 'isRecommend',
      label: '是否推荐',
      rules: [{ required: false, message: '请输入是否推荐' }],
      render: <Switch
        defaultChecked={data?.isRecommend === 1}
        checkedChildren='启用'
        unCheckedChildren='隐藏'
      />,
    },
  ];

  return (
    <FormModal
      title="店铺"
      visible={visible}
      formData={formData}
      initialValues={data}
      onChange={handleSubmit}
    />
  );
}

export default BannderEdit;
